jQuery(function($) {

  var $window = $(window);
  var $header = $('.js-header');
  var $pageNav = $('.js-page-nav');
  var scrollCount1 = 70;
  var scrollCount2 = 170;
  var $navFilter = $('.js-nav-filter');
  var $navFilterReset = $('.js-nav-filter-reset');
  var $portfolioItem = $('.js-portfolio-item');

  $navFilter.click(function(event) {
    event.preventDefault();
    var filter = $(this).data('filter');
    $navFilter.removeClass('m-current');
    $(this).addClass('m-current');
    $portfolioItem.addClass('m-not-active');
    $('.js-portfolio-item[data-tag~='+filter+']').removeClass('m-not-active');
  });

  $navFilterReset.click(function(event) {
    event.preventDefault();
    $portfolioItem.removeClass('m-not-active');
  });

  var urlRegex = /(https?:\/\/[^\s]+)/g;
  $('.js-portfolio-item').each(function() {
    var content = $(this).data('content');
    var urls = content.match(urlRegex);
    if(content && urls && urls.length) {
      $(this).attr('href', urls[0]);
      $(this).attr('target', '_blank');
    }
  });

  $window.scroll(function(){
    if($(this).scrollTop() > scrollCount1) {
      $header.addClass('m-fixed');
    } else {
      $header.removeClass('m-fixed');
    }
    if($(this).scrollTop() > scrollCount2) {
      $pageNav.addClass('m-fixed');
    } else {
      $pageNav.removeClass('m-fixed');
    }
  });

  $('.js-to-top').hide();
  var lastScrollTop = 0;
  $(window).on('scroll', function() {
    st = $(this).scrollTop();

    if(st < lastScrollTop) {
      if (st > ($(window).height() * 2 )) {
        $('.js-to-top').fadeIn(200);
      } else {
        $('.js-to-top').fadeOut();
      }
    }
    else {
      $('.js-to-top').fadeOut();
    }
    lastScrollTop = st;
    
  });

  $('.js-to-top').click(function(event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });

  $('.js-collections-item').click(function(event) {
    event.preventDefault();
    var anchor = $(this).data('anchor');
    $('html,body').animate({
      scrollTop: $('#'+anchor).offset().top - 100
    }, 500);
  });

  $('.m-scroll-anchor').click(function(event) {
    event.preventDefault();
    var anchor = $(this).data('anchor');
    $('html,body').animate({
      scrollTop: $('#'+anchor).offset().top
    }, 500);
  });

  var cook = Cookies.get('confirm-cookies');
  if(cook) {
    $('.js-cookie').hide();
  }

  $('.js-cookie-close').click(function() {
    $('.js-cookie').fadeOut();
    Cookies.set('confirm-cookies', true);
  });

  $('.js-shop-shipping-popup-close').click(function() {
    $('.js-shop-shipping-popup').fadeOut();
  });

  $('.js-open-signup-form').click(function(event) {
    event.preventDefault();
    $('.js-signup-form').fadeIn(200);
  });

  $('.js-close-signup-form').click(function(event) {
    event.preventDefault();
    $('.js-signup-form').fadeOut(200);
  });

  $('.js-open-search-popup').click(function(event) {
    event.preventDefault();
    $('.js-search-popup').fadeIn(200);
    $('.js-search-popup input[type="text"]').focus();
    $('.l-main-master').addClass('m-fix');
  });

  $('.js-close-search-popup').click(function(event) {
    event.preventDefault();
    $('.js-search-popup').fadeOut(200);
    $('.l-main-master').removeClass('m-fix');
  });

  $('.owl-carousel').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 5000,
    autoplaySpeed: 800,
    animateOut: 'fadeOut',
    nav: true,
    navText: '',
  });

  $('.js-collection').each(function() {
    $('.js-list-masonry').imagesLoaded( function() {
      $('.js-list-masonry').masonry({
        itemSelector: '.js-list-masonry-item',
      });
    });
  });

  $('.js-list-masonry').imagesLoaded( function() {
    $('.js-list-masonry').masonry({
      itemSelector: '.js-list-masonry-item',
    });
  });

  $('.b-search-popup input').keypress(function(e) {
    if(e.which == 13) {
      window.location = '/search?q=' + $(this).val();
    }
  });

  $('.js-toggle-mobile-nav').click(function(event) {
    event.preventDefault();
    $(this).toggleClass('m-active');
    $('.js-mobile-nav').toggleClass('m-open');
    $('.l-main-master').toggleClass('m-fix');
  });

  var urlParams = new URLSearchParams(window.location.search);
  var blogTag = urlParams.get('tag');

  if (blogTag) {
    $('[data-filter="'+ blogTag +'"').click();
  }

});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}